import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import { CinLoaderFull } from "@cinnamon/design-system/blocks";
import { cinTheme } from "@cinnamon/design-system/constants";
import { CinDesignSystemProvider, CinErrorBoundary } from "@cinnamon/design-system/providers";
import "@helper/i18n";
import store from "@redux/store";

import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root");

const root = createRoot(container!);

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();
  window.location.reload();
});

root.render(
  <StrictMode>
    <Suspense fallback={<CinLoaderFull />}>
      <Provider store={store}>
        <CinDesignSystemProvider theme={cinTheme}>
          <CinErrorBoundary>
            <App />
          </CinErrorBoundary>
        </CinDesignSystemProvider>
      </Provider>
    </Suspense>
  </StrictMode>
);
